module.exports = __webpack_public_path__ + "static/media/1_A_PDL_North_003_ACL.b03f2fa0.jpg";